export const getConfigSelector = state => state.config;
export const getProtocoloSomenteLeituraSelector = state =>
  getConfigSelector(state)?.protocoloSomenteLeitura || false;
export const getConfigExternaSelector = state => state.configExterna;
